import * as React from 'react';
import { SVGProps } from 'react';

const IconLaptopStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2ZM16 12H0v2h16v-2Z" />
  </svg>
);
export default IconLaptopStrokedSizeS;
